var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wkb-entity-column" }, [
    _c("div", { staticClass: "wkb-entity-column-head" }, [
      _c("h4", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "button",
        {
          staticClass: "wkb-entity-add-link",
          attrs: { type: "button", "aria-label": _vm.addModalTitle },
          on: { click: _vm.openAddModal },
        },
        [_vm._v(" Add + ")]
      ),
    ]),
    _vm.items.length
      ? _c(
          "div",
          { staticClass: "wkb-entity-chips" },
          _vm._l(_vm.items, function (item) {
            return _c(
              "div",
              { key: item.node_id, staticClass: "wkb-entity-chip" },
              [
                _c("div", { staticClass: "wkb-entity-chip-text" }, [
                  _c("strong", [_vm._v(_vm._s(_vm.displayLabel(item)))]),
                  _vm.showChipSubtitle(item)
                    ? _c("span", { staticClass: "wkb-entity-chip-sub" }, [
                        _vm._v(" " + _vm._s(item.subtitle) + " "),
                      ])
                    : _vm._e(),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "wkb-entity-chip-remove",
                    attrs: {
                      type: "button",
                      "aria-label": `Remove ${item.label}`,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("remove", item.node_id)
                      },
                    },
                  },
                  [_vm._v(" × ")]
                ),
              ]
            )
          }),
          0
        )
      : _c("p", { staticClass: "wkb-entity-empty" }, [
          _vm._v(" No " + _vm._s(_vm.title.toLowerCase()) + " selected yet. "),
        ]),
    _vm.addModalOpen
      ? _c(
          "div",
          {
            staticClass: "wkb-entity-add-backdrop",
            attrs: { role: "presentation" },
          },
          [
            _c(
              "div",
              {
                staticClass: "wkb-entity-add-modal",
                attrs: {
                  role: "dialog",
                  "aria-modal": "true",
                  "aria-labelledby": `wkb-entity-add-title-${_vm.columnKey}`,
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "wkb-entity-add-close",
                    attrs: { type: "button", "aria-label": "Close" },
                    on: { click: _vm.closeAddModal },
                  },
                  [_vm._v(" × ")]
                ),
                _c(
                  "h3",
                  { attrs: { id: `wkb-entity-add-title-${_vm.columnKey}` } },
                  [_vm._v(_vm._s(_vm.addModalTitle))]
                ),
                _c(
                  "div",
                  { staticClass: "wkb-entity-add-search" },
                  [
                    _c("div", { staticClass: "wkb-entity-add-search-field" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.autocompleteQuery,
                            expression: "autocompleteQuery",
                          },
                        ],
                        ref: "searchInput",
                        staticClass: "wkb-entity-add-input",
                        attrs: {
                          type: "text",
                          placeholder: _vm.searchPlaceholder,
                          "aria-label": _vm.searchPlaceholder,
                        },
                        domProps: { value: _vm.autocompleteQuery },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.autocompleteQuery = $event.target.value
                          },
                        },
                      }),
                      _vm.autocompleteQuery
                        ? _c(
                            "button",
                            {
                              staticClass: "wkb-entity-search-clear",
                              attrs: {
                                type: "button",
                                "aria-label": "Clear search",
                              },
                              on: { click: _vm.clearSearchInput },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "wkb-entity-search-clear-glyph",
                                  attrs: { "aria-hidden": "true" },
                                },
                                [_vm._v("×")]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm.autocompleteLoading
                      ? _c("p", { staticClass: "wkb-entity-add-status" }, [
                          _vm._v(" Searching… "),
                        ])
                      : _vm.geneSetSearchUnavailableNote
                      ? _c("p", { staticClass: "wkb-entity-llm-note" }, [
                          _vm._v(
                            " " + _vm._s(_vm.geneSetSearchUnavailableNote) + " "
                          ),
                        ])
                      : _vm._e(),
                    _c(
                      "transition",
                      { attrs: { name: "wkb-entity-added-fade" } },
                      [
                        _vm.selectedFeedbackVisible
                          ? _c(
                              "p",
                              {
                                staticClass: "wkb-entity-added-note",
                                attrs: { role: "status" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.selectedFeedbackMessage) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm.conceptualSearchEnabled
                      ? _c(
                          "button",
                          {
                            staticClass: "wkb-entity-conceptual-link",
                            attrs: {
                              type: "button",
                              disabled:
                                _vm.semanticLoading ||
                                !_vm.autocompleteQuery.trim(),
                            },
                            on: { click: _vm.runSemanticMatch },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.semanticLoading
                                    ? "Finding conceptual matches…"
                                    : "+ Add conceptual matches"
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                !_vm.showConceptualTabs
                  ? [
                      _vm.autocompleteSuggestions.length
                        ? _c(
                            "ul",
                            { staticClass: "wkb-entity-suggestions" },
                            _vm._l(
                              _vm.autocompleteSuggestions,
                              function (item, index) {
                                return _c(
                                  "li",
                                  {
                                    key:
                                      _vm.entityKey(item) || `catalog-${index}`,
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "wkb-entity-suggestion",
                                        class: {
                                          "is-added":
                                            _vm.isAlreadySelected(item),
                                        },
                                        attrs: {
                                          type: "button",
                                          "aria-disabled":
                                            _vm.isAlreadySelected(item),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addItem(item)
                                          },
                                        },
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(_vm.displayLabel(item))
                                          ),
                                        ]),
                                        _vm.subtitleFor(item)
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.subtitleFor(item))
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                    ]
                  : [
                      _c(
                        "div",
                        {
                          staticClass: "wkb-entity-result-tabs",
                          attrs: { role: "tablist" },
                        },
                        [
                          _c(
                            "button",
                            {
                              class: [
                                "wkb-entity-result-tab",
                                _vm.matchTab === "catalog" && "is-active",
                              ],
                              attrs: {
                                type: "button",
                                role: "tab",
                                "aria-selected": _vm.matchTab === "catalog",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.matchTab = "catalog"
                                },
                              },
                            },
                            [_vm._v(" From catalog ")]
                          ),
                          _c(
                            "button",
                            {
                              class: [
                                "wkb-entity-result-tab",
                                _vm.matchTab === "conceptual" && "is-active",
                              ],
                              attrs: {
                                type: "button",
                                role: "tab",
                                "aria-selected": _vm.matchTab === "conceptual",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.matchTab = "conceptual"
                                },
                              },
                            },
                            [_vm._v(" By conceptual search ")]
                          ),
                        ]
                      ),
                      _c(
                        "ul",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.matchTab === "catalog" &&
                                _vm.autocompleteSuggestions.length,
                              expression:
                                "matchTab === 'catalog' && autocompleteSuggestions.length",
                            },
                          ],
                          staticClass: "wkb-entity-suggestions",
                        },
                        _vm._l(
                          _vm.autocompleteSuggestions,
                          function (item, index) {
                            return _c(
                              "li",
                              {
                                key: _vm.entityKey(item) || `catalog-${index}`,
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "wkb-entity-suggestion",
                                    class: {
                                      "is-added": _vm.isAlreadySelected(item),
                                    },
                                    attrs: {
                                      type: "button",
                                      "aria-disabled":
                                        _vm.isAlreadySelected(item),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addItem(item)
                                      },
                                    },
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.displayLabel(item))),
                                    ]),
                                    _vm.subtitleFor(item)
                                      ? _c("span", [
                                          _vm._v(_vm._s(_vm.subtitleFor(item))),
                                        ])
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                      _c(
                        "ul",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.matchTab === "conceptual" &&
                                _vm.semanticMatches.length,
                              expression:
                                "matchTab === 'conceptual' && semanticMatches.length",
                            },
                          ],
                          staticClass: "wkb-entity-suggestions",
                        },
                        _vm._l(_vm.semanticMatches, function (item, index) {
                          return _c(
                            "li",
                            {
                              key: _vm.entityKey(item) || `conceptual-${index}`,
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "wkb-entity-suggestion",
                                  class: {
                                    "is-added": _vm.isAlreadySelected(item),
                                  },
                                  attrs: {
                                    type: "button",
                                    "aria-disabled":
                                      _vm.isAlreadySelected(item),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addItem(item)
                                    },
                                  },
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.displayLabel(item))),
                                  ]),
                                  _vm.subtitleFor(item)
                                    ? _c("span", [
                                        _vm._v(_vm._s(_vm.subtitleFor(item))),
                                      ])
                                    : _vm._e(),
                                  item.rationale
                                    ? _c(
                                        "span",
                                        { staticClass: "wkb-entity-rationale" },
                                        [
                                          _vm._v(
                                            " " + _vm._s(item.rationale) + " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ],
                _vm.entityType !== "gene_set" && !_vm.llmAvailable
                  ? _c("p", { staticClass: "wkb-entity-llm-note" }, [
                      _vm._v(
                        " Conceptual search requires LLM support on the server. "
                      ),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }